import React, {useEffect, useState} from "react";

/** Fades/slides children in after `delay` ms. */
const FadeIn = ({delay = 0, className = "", children}) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const timeout = setTimeout(() => setVisible(true), delay);
        return () => clearTimeout(timeout);
    }, [delay]);

    return (
        <div
            className={`transition-all duration-700 ease-out ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            } ${className}`}
        >
            {children}
        </div>
    );
};

export default FadeIn;